export const sortBySortValue = <T>(items: T[], getSortValue: (item: T) => string): T[] =>
  [...items].sort((a, b) => getSortValue(a).localeCompare(getSortValue(b)))
